// import SiteEvents, { SiteEventNames } from '../util/site-events';

class ConnectedRecruitingMenu {
	constructor(el) {
		this.el = el;
        let timeOutFunctionId;

        this.recruitingMenu();

        addEventListener('resize', (event) => {
            clearTimeout(timeOutFunctionId);
            timeOutFunctionId = setTimeout(() => {
                this.handleResize();
                this.resize();
            }, 200);
        });
    }

    handleResize() {
        $('html.mobile-menu-active').removeClass('mobile-menu-active');
        $('.recruiting-menu .active').removeClass('active');
    }

    recruitingMenu() {
        const menuBreakpoint = 1024;

        if( $('body').hasClass('page-template-page-recruiting') ) {
            $('.recruiting-menu > .menu-item.menu-item-has-children > .sub-menu .menu-item-has-children > a').on('click tap', function(e) {
                e.preventDefault();
            });

            $('.recruiting-menu .button').each(function() {
                $(this).removeClass('button').addClass('button-wrapper').find('a').addClass('button');
            });

            // Mobile only
            if( this.viewportInfo().width <= menuBreakpoint ) {
                $('.site-header__mobile-menu-button').on('click tap', function() {
                    $('.recruiting-menu .active').removeClass('active');
                    // $('html').toggleClass('mobile-menu-active');
                });
    
                // trigger the mobile action
                $('.recruiting-menu .level-0 > a').on('click tap', function(e) {
                    e.preventDefault();

                    if( $(this).closest('.menu-item').hasClass('active') ) {
                        $(this).closest('.menu-item').removeClass('active');
                    }else{
                        $('.recruiting-menu .active').removeClass('active');
                        $(this).closest('.menu-item').addClass('active');
                    }
                });
            }
        }
    }

    resize() {
        $('.recruiting-menu .active').removeClass('active');
        $('html').removeClass('mobile-menu-active');
    }

    viewportInfo() {
        var e = window, a = 'inner';
        if (!('innerWidth' in window )) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
    }
}

export default ConnectedRecruitingMenu;
